import React from "react";
import "./NavBar.css";
function NavBar() {
  return (
    <nav>
      <ul>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
        <li>
          <a href="https://www.dhiu.in/">Home</a>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
